import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=055dd9fa&"
import script from "./RouteDetail.vue?vue&type=script&lang=js&"
export * from "./RouteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports